import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { supportLabels } from "@/i18n";

export const HowAuctionsWork = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const c = supportLabels(language).docGuideContent?.howAuctionsWork ?? {};
  const isDark = theme === "dark";

  const goodToKnow = Array.isArray(c.step1GoodToKnowList)
    ? (c.step1GoodToKnowList as string[])
    : [];

  const stepItems = (n: 1 | 2 | 3 | 4) => {
    const keys = [`step${n}Item1`, `step${n}Item2`, `step${n}Item3`] as const;
    return keys.map((k) => c[k]).filter(Boolean) as string[];
  };

  const steps: { title: string; items: string[]; goodToKnow?: boolean }[] = [
    {
      title: c.step1Title ?? "",
      items: stepItems(1),
      goodToKnow: goodToKnow.length > 0,
    },
    { title: c.step2Title ?? "", items: stepItems(2) },
    { title: c.step3Title ?? "", items: stepItems(3) },
    { title: c.step4Title ?? "", items: stepItems(4) },
  ];

  return (
    <div className="space-y-6">
      {steps.map((s, i) => (
        <div key={i}>
          <div className="flex items-start gap-3 mb-4">
            <div
              className={`w-8 h-8 rounded-full mt-1 flex-shrink-0 flex items-center justify-center text-sm font-bold ${
                isDark ? "bg-blue-500 text-white" : "bg-blue-600 text-white"
              }`}
            >
              {i + 1}
            </div>
            <div className="flex-1">
              <h4
                className={`font-semibold mb-2 text-base ${
                  isDark ? "text-white" : "text-black"
                }`}
              >
                {s.title}
              </h4>
              <ul
                className={`text-sm space-y-1 ${
                  isDark ? "text-gray-300" : "text-gray-700"
                }`}
              >
                {s.items.map((item, j) => (
                  <li key={j}>• {item}</li>
                ))}
              </ul>
              {s.goodToKnow && c.step1GoodToKnowTitle && (
                <div className="mt-3">
                  <p
                    className={`text-sm font-semibold mb-1 ${
                      isDark ? "text-gray-200" : "text-gray-800"
                    }`}
                  >
                    {c.step1GoodToKnowTitle}
                  </p>
                  <ul
                    className={`text-sm space-y-1 ${
                      isDark ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    {goodToKnow.map((line, j) => (
                      <li key={j}>• {line}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
